import { provideFluentDesignSystem } from '@fluentui/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import * as React from 'react';

const { wrap: wrapFluentWebComponent } = provideReactWrapper(React, provideFluentDesignSystem());

export default wrapFluentWebComponent;
